import { ReactNode, useState } from "react";
import StakeRow from "./StakeRow";
import { STAKE_CONTRACTS } from "../constants/constrants";

type Props = {
  children?: ReactNode;
};

export default function StakeTable({ children }: Props) {
  const [isActiveStakes, setIsActiveStakes] = useState(true);
  const [isOnlyStaked, setOnlyStaked] = useState(0);
  const [filterType, setFilterType] = useState(0);

  //const contracts =  useAllPools()
  
  //const contracts = useMasterStakeContact()
  const contracts = STAKE_CONTRACTS

  return (
    <div className="gamfi-farming gamfi-previous-section pt-70 pb-130 md-pb-60">
      <div className="container">
        <div className="project-menu-area d-flex align-items-center justify-content-between">
          <div className="project-left-menu">
            <ul className="nav" id="myTab" role="">
              <li className="nav-item" role="">
                <button
                  className={`tab-link ${isActiveStakes ? "active" : ""}`}
                  onClick={() => setIsActiveStakes(true)}
                >
                  Active Pools
                </button>
              </li>
              <li className="nav-item" role="">
                <button
                  className={`tab-link ${!isActiveStakes ? "active" : ""}`}
                  onClick={() => setIsActiveStakes(false)}
                >
                  Inactive Pools
                </button>
              </li>
              {/*<li className="form-switch" id="addswitchclass">
                <Switch
                  colorScheme="green"
                  value={isOnlyStaked}
                  onChange={(val: any) => {
                    setOnlyStaked(val.target.checked);
                  }}
                />
                <span className="title" style={{ color: "#ffffffb3" }}>
                  Staked Only
                </span>
                </li>*/}
            </ul>
          </div>
          <div className="project-right-menu">
            <ul className="al-access-menu right-postion">
              <li>
                <a className="hoverable" onClick={() => setFilterType(0)}>
                  All Pools
                </a>
                <ul className="sub-menu">
                  <li>
                    <a className="hoverable" onClick={() => setFilterType(1)}>
                      Staking Pools
                    </a>
                  </li>
                  {/*<li>
                    <a className="hoverable" onClick={() => setFilterType(2)}>
                      Farming Pools
                    </a>
              </li>*/}
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="gamfi-farming-table">
          <table>
            <tbody>
              <tr>
                <th>Pools {isActiveStakes}</th>
                <th>APY</th>
                <th>STAKED</th>
                <th>TVL</th>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="gamfi-farming-content" id="active-tab">
          {isActiveStakes == true ? (
            contracts && contracts.map(
              (object, i) =>
                object.finishTime * 1000 > new Date().getTime() &&
                (isOnlyStaked ? object.isStaked : true) &&
                (filterType != 0 ? filterType == object.type : true) && (
                  <StakeRow
                    key={i}
                    imgUrl={object.imgUrl}
                    name={object.name}
                    tokenName={object.tokenName}
                    isActive={object.isActive}
                    contractAddr={object.contract}
                    buyUrl={object.buyUrl}
                    buyUrlText={object.buyUrlText}
                    startPeriod={object.startTime}
                    finishPeriod={object.finishTime}
                  />
                )
            )
          ) : (
            <></>
          )}
        </div>

        <div className="gamfi-farming-content" id="passive-tab">
          {isActiveStakes == false ? (
            contracts && contracts.map(
              (object, j) =>
              object.finishTime * 1000 < new Date().getTime() &&
                (isOnlyStaked ? object.isStaked : true) &&
                (filterType != 0 ? filterType == object.type : true) && ( 
                  <StakeRow
                    key={j}
                    imgUrl={object.imgUrl}
                    name={object.name}
                    tokenName={object.tokenName}
                    isActive={object.isActive}
                    contractAddr={object.contract}
                    buyUrl={object.buyUrl}
                    buyUrlText={object.buyUrlText}
                    startPeriod={object.startTime}
                    finishPeriod={object.finishTime}
                  />
                )
            )
          ) : (
            <></>
          )}
        </div>
        <div className="text-center p-5">
          <span className="text-warning">The staking model here is no longer active; please proceed to the new staking portal.<br></br>If you wish to withdraw assets you've staked in these pools, please check the "inactive pools" tab above.</span>
          <div className="btn-area pt-50">
            <a className="btn btn-lg readon black-shape portalbtn text-dark fw-bolder" href="https://portal.hera.finance" target="blank">
              <span className="btn-text">New Staking Portal ↗</span>
              <span className="hover-shape1" />
              <span className="hover-shape2" />
              <span className="hover-shape3" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
